import { createSelector } from '@ngrx/store';
import * as fromReducers from '../reducers';
import * as fromFlightSearchNewReducer from '../reducers/flight-search.reducers';

export const getFlightSearchState = createSelector(
  fromReducers.getTravelSearchState,
  (state: fromReducers.TravelSearchState) => state.flightSearch
);

export const getAirlinesState = createSelector(getFlightSearchState, (state) => state.airlines);
export const getItinerariesState = createSelector(getFlightSearchState, (state) => state.itineraries);
export const getFilteredItinerariesState = createSelector(getFlightSearchState, (state) => state.filteredItineraries);
export const getLegsState = createSelector(getFlightSearchState, (state) => state.legs);
export const getLocationsState = createSelector(getFlightSearchState, (state) => state.locations);
export const getSegmentsState = createSelector(getFlightSearchState, (state) => state.segments);

export const {
  selectAll: selectAirlines,
  selectEntities: selectAirlineEntities,
  selectIds: selectAirlineIds,
} = fromFlightSearchNewReducer.airlinesAdapter.getSelectors(getAirlinesState);

export const {
  selectAll: selectItineraries,
  selectEntities: selectItineraryEntities,
  selectIds: selectItineraryIds,
} = fromFlightSearchNewReducer.itineraryAdapter.getSelectors(getItinerariesState);

export const {
  selectAll: selectFilteredItineraries,
  selectEntities: selectFilteredItineraryEntities,
  selectIds: selectFilteredItineraryIds,
} = fromFlightSearchNewReducer.itineraryAdapter.getSelectors(getFilteredItinerariesState);

export const {
  selectAll: selectLegs,
  selectEntities: selectLegEntities,
  selectIds: selectLegIds,
} = fromFlightSearchNewReducer.legAdapter.getSelectors(getLegsState);

export const {
  selectAll: selectSegments,
  selectEntities: selectSegmentEntities,
  selectIds: selectSegmentIds,
} = fromFlightSearchNewReducer.segmentAdapter.getSelectors(getSegmentsState);

export const {
  selectAll: selectLocations,
  selectEntities: selectLocationEntities,
  selectIds: selectLocationIds,
} = fromFlightSearchNewReducer.locationAdapter.getSelectors(getLocationsState);

export const getFlightSearchNewNumberOfFilteredItineraries = createSelector(
  getFlightSearchState,
  fromFlightSearchNewReducer.getNumberOfFilteredItineraries
);

export const getFlightSearchNewReferenceId = createSelector(
  getFlightSearchState,
  fromFlightSearchNewReducer.getSearchReferenceId
);

export const getFlightSearchNewResultsLoaded = createSelector(
  getFlightSearchState,
  fromFlightSearchNewReducer.getResultsLoaded
);
export const getFlightNavigateFromTravelSearchPage = createSelector(
  getFlightSearchState,
  fromFlightSearchNewReducer.getNavigateFromTravelSearchPage
);
export const getFlightsFareFamilies = createSelector(getFlightSearchState, fromFlightSearchNewReducer.getFareFamilies);
export const getFlightsNewFiltersData = createSelector(getFlightSearchState, fromFlightSearchNewReducer.getFilters);
export const getFlightsNewSearchData = createSelector(getFlightSearchState, fromFlightSearchNewReducer.getSearchData);
export const getFlightsNewSelectedFlight = createSelector(
  getFlightSearchState,
  fromFlightSearchNewReducer.getSelectedFlight
);
export const getSelectedFareFamily = createSelector(
  getFlightSearchState,
  fromFlightSearchNewReducer.getSelectedFareFamily
);
export const getFlightSearchNewAirlineById = (id: number) =>
  createSelector(selectAirlineEntities, (airlines) => airlines[id]);
export const getFlightSearchNewLocationById = (id: number) =>
  createSelector(selectLocationEntities, (locations) => locations[id]);
export const getFlightSearchNewLegById = (id: string) => createSelector(selectLegEntities, (legs) => legs[id]);
export const getFlightSearchNewSegmentById = (id: string) =>
  createSelector(selectSegmentEntities, (segments) => segments[id]);
